import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/authContext";
import { ToastContainer } from "react-toastify";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51RA9Eo2eHO52aOFEhJQzHAepW80zxaom26zZGbUYzyzogaupQweN65WTPqEvgM1NWg4LZNAMvO7myfPvNdUxDqo900iMAa3295"
);
const root = ReactDOM.createRoot(document.getElementById("root"));
const options = {
  mode: "payment",
  amount: 1099,
  currency: "usd",
};
root.render(
  <AuthProvider>
    <Elements stripe={stripePromise} options={options}>
      <ToastContainer />
      <App />
    </Elements>
  </AuthProvider>
);

reportWebVitals();
